/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const RecurringPattern = {
    Single: "single",
    Daily: "daily",
    Workdays: "workdays",
    Weekends: "weekends",
    Weekly: "weekly",
    Monthly: "monthly",
};
export function instanceOfRecurringPattern(value) {
    for (const key in RecurringPattern) {
        if (Object.prototype.hasOwnProperty.call(RecurringPattern, key)) {
            if (RecurringPattern[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function RecurringPatternFromJSON(json) {
    return RecurringPatternFromJSONTyped(json, false);
}
export function RecurringPatternFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RecurringPatternToJSON(value) {
    return value;
}
